import Clipboard from 'clipboard'

$(document).ready(function () {
    var clipboard = new Clipboard('.clipboard');
    clipboard.on('success', function(e) {
        showTooltip(e.trigger, 'Copied!');
    });
    clipboard.on('error', function(e) {
    });
});

function showTooltip(elem, msg) {
    elem.setAttribute('class', 'clipboard tooltipped');
    elem.setAttribute('aria-label', msg);
    setTimeout(removeTooltip, 1000, elem);
}

function removeTooltip(elem) {

    elem.setAttribute('class', 'clipboard');
}